const viewAny = (permissions) => {
  return permissions.includes('read-countries')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-countries')
}

const update = (permissions, country) => {
  return hasPermission(permissions, 'update-countries')
}

const deletee = (permissions, country) => {
  return hasPermission(permissions, 'delete-countries')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};